import { render, staticRenderFns } from "./TicketInfo.vue?vue&type=template&id=d2ca1e42&"
import script from "./TicketInfo.vue?vue&type=script&lang=ts&"
export * from "./TicketInfo.vue?vue&type=script&lang=ts&"
import style0 from "./TicketInfo.vue?vue&type=style&index=0&id=d2ca1e42&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports